module.exports = __webpack_public_path__ + "static/media/american-sign-language-interpreting.19f029f0.svg";